import { useSelector } from 'react-redux';
import { ImportExcelKdvButton, ImportExcelNomenclatureButton, ImportExcelNomenclatureStocksButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { H1 } from '../../../components/Basic/WrapsStyle';

function NomenclaturePage({ }) {
  const user = useSelector((store) => store.user);
  const isOwner = user.role === 'owner' || user.role === 'admin';

  return (
    <>
      <Content>
        <H1 style={{ marginBottom: '-3px', marginBottom: '20px' }}>Номенклатура</H1>

        <ImportExcelNomenclatureButton />
        {isOwner && <ImportExcelKdvButton />}
        {isOwner && <ImportExcelNomenclatureStocksButton />}
      </Content>
    </>
  );
}

export default NomenclaturePage;
